<template>
  <div :class="{ 'mb-4 pb-1 border-bottom': form.isDriver }">
    <!-- McToggle component for "Atur Kata Sandi" -->
    <McToggle
      :value="form.toggleVerification"
      :label="$t('master.user.accessVerification.title')"
      placement="left"
      @input="$emit('update-form', { toggleVerification: $event })"
    />
    <!-- Paragraf ini perlu di-indentasi agar sejajar dengan label McToggle -->
    <p class="text-muted mb-3 mc-user-modal__sub-section-indent">
      {{ $t('master.user.accessVerification.description') }}
    </p>

    <!-- Direct Password Fields - Tampilkan saat toggle diaktifkan -->
    <!-- Div ini perlu di-indentasi agar sejajar dengan label McToggle -->
    <div v-if="form.toggleVerification" class="mt-3 mc-user-modal__sub-section-indent">
      <!-- Div ini tidak perlu indentasi, biarkan sejajar dengan judul -->
      <b-form-group>
        <!-- WhatsApp Option -->
        <div
          class="mc-user-modal__password-method-card mb-3"
          :class="{
            'mc-user-modal__password-method-card--selected':
              form.setVerification === 'phoneNumber' && form.phoneNo,
            'mc-user-modal__password-method-card--disabled': !form.phoneNo || form.isPhoneVerified,
          }"
          @click="form.phoneNo && $emit('update-form', { setVerification: 'phoneNumber' })"
        >
          <div class="d-flex align-items-center justify-content-between p-3">
            <div class="d-flex align-items-center">
              <b-form-radio
                v-model="verificationValue"
                plain
                value="phoneNumber"
                class="me-3"
                :disabled="!form.phoneNo || form.isPhoneVerified"
                @change="$emit('update-form', { setVerification: 'phoneNumber' })"
              />
              <i
                class="icon-outline_whatsapp me-3 mc-user-modal__icon-whatsapp"
                :class="{ 'mc-user-modal__icon--muted': !form.phoneNo }"
              />
              <span :class="{ 'text-muted': !form.phoneNo }">
                {{ $t('master.user.whatsappTo') }}
              </span>
            </div>
            <span :class="{ 'text-muted': !form.phoneNo }">
              {{ form.phoneNo ? `+${form.phoneNo}` : '-' }}
            </span>
          </div>
        </div>

        <!-- Email Option -->
        <div
          v-if="!form.isEmailVerified"
          class="mc-user-modal__password-method-card mb-3"
          :class="{
            'mc-user-modal__password-method-card--selected':
              form.setVerification === 'email' && form.email,
            'mc-user-modal__password-method-card--disabled': !form.email || form.isEmailVerified,
          }"
          @click="form.email && $emit('update-form', { setVerification: 'email' })"
        >
          <div class="d-flex align-items-center justify-content-between p-3">
            <div class="d-flex align-items-center">
              <b-form-radio
                v-model="verificationValue"
                plain
                value="email"
                class="me-3"
                :disabled="!form.email || form.isEmailVerified"
                @change="$emit('update-form', { setVerification: 'email' })"
              />
              <i
                class="icon-outline_email me-3 mc-user-modal__icon-email"
                style="font-size: 1.1rem"
                :class="{ 'mc-user-modal__icon--muted': !form.email }"
              />
              <span :class="{ 'text-muted': !form.email }">
                {{ $t('master.user.emailTo') }}
              </span>
            </div>
            <span :class="{ 'text-muted': !form.email }">
              {{ form.email || '-' }}
            </span>
          </div>
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import McToggle from '@/components/McToggle'

export default {
  name: 'AccessVerificationSection',

  components: {
    McToggle,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  computed: {
    verificationValue: {
      get() {
        return this.form.setVerification
      },
      set(val) {
        this.$emit('update-form', {
          ...this.form,
          setVerification: val,
        })
      },
    },
  },
}
</script>
